import {useMemo} from "react";

import {useAppSelector} from "../../store/hooks";
import {getAmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {IRegistrationWizardTrackingContext} from "../tracking/track_registration_wizard_events";
import {getAmplitudeFlowTracking} from "../utils/get_amplitude_flow_tracking";

export const useRegistrationWizardTrackingContext = (): IRegistrationWizardTrackingContext => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const amplitudePlacement = useAppSelector((state) => state.registrationFlow.amplitudePlacement);
    const amplitudeLocation = useAppSelector((state) => state.registrationFlow.amplitudeLocation);
    const itemId = useAppSelector((state) => state.registrationFlow.offerId ?? null);
    const propertyId = useAppSelector((state) => state.registrationFlow.propertyId ?? null);

    return useMemo(() => {
        const {placement, location} = getAmplitudeFlowTracking({amplitudePlacement, amplitudeLocation}, getAmplitudeAuthLocation(viewType));

        return {authPlacement: placement, location, itemId, propertyId};
    }, [amplitudePlacement, amplitudeLocation, viewType, itemId, propertyId]);
};
import {useMemo} from "react";

import {useAppSelector} from "../../store/hooks";
import {getAmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {IRegistrationWizardTrackingContext} from "../tracking/track_registration_wizard_events";
import {getAmplitudeFlowTracking} from "../utils/get_amplitude_flow_tracking";

export const useRegistrationWizardTrackingContext = (): IRegistrationWizardTrackingContext => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const amplitudePlacement = useAppSelector((state) => state.registrationFlow.amplitudePlacement);
    const amplitudeLocation = useAppSelector((state) => state.registrationFlow.amplitudeLocation);
    const itemId = useAppSelector((state) => state.registrationFlow.offerId ?? null);
    const propertyId = useAppSelector((state) => state.registrationFlow.propertyId ?? null);

    return useMemo(() => {
        const {placement, location} = getAmplitudeFlowTracking({amplitudePlacement, amplitudeLocation}, getAmplitudeAuthLocation(viewType));

        return {authPlacement: placement, location, itemId, propertyId};
    }, [amplitudePlacement, amplitudeLocation, viewType, itemId, propertyId]);
};
